import React from "react";
import AjudaModal from "./AjudaModal";

function AjudaPressupost({ pestanya, onTancar }) {
  const contingut = CONTINGUT[pestanya] || CONTINGUT.llista;
  return (
    <AjudaModal
      id="pressupost-ajuda-title"
      titol={contingut.titol}
      lead={contingut.lead}
      onTancar={onTancar}
    >
      {contingut.cos}
    </AjudaModal>
  );
}

const CONTINGUT = {
  llista: {
    titol: "Com funcionen els Pressupostos",
    lead: "Un Pressupost és el document comercial d'una proposta a un client. Les Versions i les Partides viuen a dins; no es barregen amb el que ja s'ha acceptat.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic a la fila per consultar. El menú <strong>…</strong> obre Consultar, Modificar, Esborrar, Ofertes i Versions.</li>
            <li>Per defecte es veuen els <strong>Esborrany</strong>. Si véns d'un client, no es filtra per estat.</li>
            <li>La cerca mira client, adreça, població i comentaris.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Seccions de la fitxa</h4>
          <p>
            Un cop dins, el subnav canvia de bloc sense tornar a la llista: Dades, Ofertes i Versions.
            Les Ofertes són les del proveïdor per a aquest pressupost. Les Versions i les seves partides
            es gestionen a la secció Versions.
          </p>
        </section>
      </>
    ),
  },
  dades: {
    titol: "Com funciona la fitxa del Pressupost",
    lead: "El número, l'estat i els imports són informació. El que s'edita és el client, el contacte, la descripció, el benefici, l'adreça i l'intermediari.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Blocs</h4>
          <ul>
            <li>
              <strong>1. Identificació</strong> (consulta i modificació): número intern, estat global i versió
              acceptada, o el nombre de versions si encara no n'hi ha cap d'acceptada. Els preus van a sota,
              amb milers amb punt i decimals amb coma.
            </li>
            <li>
              <strong>2. Client i condicions</strong>: a la mateixa línia, data d'alta, client i contacte.
              A sota, percentatge de benefici i preu final. El select de contacte es deixa buit si el client
              no en té. En consulta, si no hi ha contacte es mostren telèfon i email del client. El recàlcul
              del preu final el fa el botó de reciclar, amb la fórmula que ja tenia la fitxa.
            </li>
            <li>
              <strong>3. Descripció</strong> del pressupost (en alta, després del client). És el mateix camp
              que els comentaris de sempre.
            </li>
            <li>
              <strong>4. Intermediari</strong>: opcional. Si s'activa, cal triar l'entitat.
            </li>
            <li>
              <strong>5. Adreça</strong>: si el camp és buit, el valor del client surt en gris. En editar-lo,
              passa a ser l'adreça d'aquest pressupost.
            </li>
          </ul>
        </section>
      </>
    ),
  },
  versions: {
    titol: "Com funcionen les Versions",
    lead: "La llista mostra totes les versions d'un cop d'ull: estat, data i preu. Les partides s'obren en una pantalla a part, per tenir espai per treballar.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic consulta la versió. El menú <strong>…</strong> obre Consultar, Modificar, Partides, Copiar i Esborrar.</li>
            <li>Entre Estat i Comentaris hi ha la data de l'estat: modificació (Esborrany), presentació, acceptació o rebuig.</li>
            <li><strong>Nova versió</strong> (a la capçalera) obre la fitxa. En desar, es crea un Esborrany buit i pots ajustar estat i comentaris.</li>
            <li>El filtre d'estat deixa veure només esborranys, presentades, acceptades o rebutjades.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <ul>
            <li>Estat, dates, imports i comentaris. <strong>Partides</strong> obre l'arbre d'aquella versió.</li>
            <li>Els imports els calcula el backend; aquí només es consulten.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Copiar versió</h4>
          <ul>
            <li>Es copien totes les partides i apartats. La còpia sempre és un <strong>Esborrany</strong> («Còpia de versió»).</li>
            <li>
              <strong>Copiar aquí</strong>: al mateix pressupost. Si no hi ha versions, serà la 1.
              Si l'última versió no té cap partida, s'hi reutilitza aquella versió buida. Si ja en té, es crea el número següent.
            </li>
            <li>
              <strong>Copiar a un altre pressupost</strong>: mateixes regles al destí. La llista del destí mostra tots els estats, no només esborranys.
            </li>
          </ul>
        </section>
      </>
    ),
  },
  partides: {
    titol: "Com funcionen les Partides",
    lead: "Les partides són el contingut d'una versió. La capçalera mostra tots els imports; si hi ha una fila seleccionada, els d'aquella partida.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Arbre</h4>
          <ul>
            <li>Una sola taula: Apartats, partides i subpartides, amb N nivells. El <strong>▶</strong> expandeix; el color cicla cada 4 nivells com a Tasques.</li>
            <li>Doble clic obre la fitxa v2. A consultar: <strong>Modificar</strong> i <strong>Més accions</strong> (Esborrar) a la capçalera. Les fletxes del peu recorren només el mateix nivell (germans del mateix pare). El menú <strong>…</strong> de la fila també obre Consultar, Modificar, l'alta de fill i Esborrar.</li>
            <li>
              A la barra, segons el nivell: <strong>Nou apartat</strong> i/o <strong>Nova partida</strong> (si el nivell és buit surten tots dos).
              Un apartat només agrupa: la fitxa té el punt 1 d'Identificació. Expandint un apartat pots crear un <strong>subapartat</strong> o una <strong>partida</strong> a dins.
              <strong>Usar plantilla</strong> i la cerca van a la mateixa línia.
              Si la versió està Presentada, Acceptada o Rebutjada, no es poden crear ni modificar partides.
            </li>
            <li>En triar un producte, el <strong>Proveïdor</strong> llista els que tenen preu (com a Tasques). Per defecte el més econòmic; a la mateixa línia: quantitat de producte, preu total material i preu manual.</li>
            <li>Els números (quantitat i preus) es veuen amb milers amb punt i decimals amb coma.</li>
            <li>Tornar des de l'arbre et deixa a la fitxa de la versió si hi has entrat des d'allà, o a la llista de versions.</li>
          </ul>
        </section>
      </>
    ),
  },
};

export default AjudaPressupost;
